let idCounter = 0;

export interface OpacitySliderHandle {
  element: HTMLElement;
  setValue: (value: number) => void;
}

/**
 * A single 30-100% opacity slider (DESIGN.md §7 "Krycie"). Two independent
 * instances are created by the app (desktop popover + mobile legend panel);
 * both call the same onChange callback, which keeps them and the RadarLayer
 * in sync via setValue.
 */
export function createOpacitySlider(
  initial: number,
  onChange: (value: number) => void
): OpacitySliderHandle {
  idCounter += 1;
  const id = `opacity-slider-${idCounter}`;

  const wrap = document.createElement("div");
  wrap.className = "opacity-slider";

  const label = document.createElement("label");
  label.className = "opacity-slider__label";
  label.htmlFor = id;
  const nameSpan = document.createElement("span");
  nameSpan.textContent = "Krycie radaru";
  const valueSpan = document.createElement("span");
  valueSpan.className = "tabular-nums";
  valueSpan.textContent = `${Math.round(initial * 100)}%`;
  label.append(nameSpan, valueSpan);

  const input = document.createElement("input");
  input.type = "range";
  input.id = id;
  input.min = "30";
  input.max = "100";
  input.step = "5";
  input.value = String(Math.round(initial * 100));
  input.setAttribute("aria-label", "Krycie warstwy radaru");

  input.addEventListener("input", () => {
    const value = Number(input.value) / 100;
    valueSpan.textContent = `${input.value}%`;
    onChange(value);
  });

  wrap.append(label, input);

  return {
    element: wrap,
    setValue: (value: number) => {
      const pct = Math.round(value * 100);
      input.value = String(pct);
      valueSpan.textContent = `${pct}%`;
    }
  };
}

/** Icon button (top-right column, desktop) that toggles the opacity popover. */
export function createOpacityToggle(popoverEl: HTMLElement): HTMLButtonElement {
  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "icon-button opacity-toggle";
  btn.setAttribute("aria-label", "Krycie warstwy radaru");
  btn.setAttribute("aria-expanded", "false");
  btn.textContent = "◐";
  btn.addEventListener("click", () => {
    const willOpen = popoverEl.hidden;
    popoverEl.hidden = !willOpen;
    btn.setAttribute("aria-expanded", String(willOpen));
  });
  return btn;
}
